module.exports = __webpack_public_path__ + "static/media/Senior-DevOps-Engineer-Administrator.32493aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/Senior-DevOps-Engineer-Administrator.png
// module id = 369
// module chunks = 0